import { useState } from "react"

import BaseTextField from "components/base/TextField"
import useInput from "hooks/use_input"
import { InputAdornment, IconButton } from "@mui/material"

import Visibility from "@mui/icons-material/Visibility"
import VisibilityOff from "@mui/icons-material/VisibilityOff"
import BaseMask from "../../base/Mask"
import useTranslation from "hooks/use_translation"

const Password = () => {
  const id = "password"
  const [showPassword, setShowPassword] = useState(false)
  const { fields } = useTranslation()

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  const handleMouseUpPassword = (event) => {
    event.preventDefault()
  }

  const validate = (value) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\W_]{8,}$/

    if (!regex.test(value)) {
      return fields?.password_error_format
    }

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <BaseTextField
      id={id}
      _label={fields?.password_title}
      value={inputValue}
      onChange={handleChange}
      error={errorMessage?.length > 0}
      onBlur={handleBlur}
      helperText={errorMessage || fields?.password_hint}
      type={showPassword ? "text" : "password"}
      InputProps={{
        inputComponent: BaseMask,
        inputProps: {
          mask: /^[a-zA-Z\d]{0,8}$/,
        },
      }}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={showPassword ? "hide the password" : "display the password"}
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  )
}

export default Password
